const Domain = {
  type: 'string',
  pattern: '^([^\\/]+\\/)+$',
};

export default Domain;
